module.exports = __webpack_public_path__ + "static/furniture-c4b2185bd151dd82ab250bfd98faffd2.jpeg";